import { Component, ViewEncapsulation, HostListener} from "@angular/core";

@Component({
    selector: "pme-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FooterComponent {
  currentYear: number = new Date().getFullYear();
}


